import React from 'react';

const IncomingScanStatusBadge = ({ item, loading = false }) => {
  if (loading) {
    return (
      <span className='badge badge-light border d-inline-flex align-items-center'>
        <span className='spinner-border spinner-border-sm mr-1' role='status' aria-hidden='true'></span>
        Пошук...
      </span>
    );
  }

  if (!item) return null;

  if (item.foundInCatalog && item.productCode) {
    return <span className='badge badge-success'>Знайдено</span>;
  }
  if (item.foundInCatalog && !item.productCode) {
    return <span className='badge badge-warning text-dark'>Не привʼязано</span>;
  }
  return <span className='badge badge-danger'>Не знайдено</span>;
};

export default IncomingScanStatusBadge;
